import React from 'react';
export function Footer() {
  return <footer className="bg-primary-dark py-12 px-4 border-t-4 border-gold text-center" data-id="element-90">
      <div className="max-w-4xl mx-auto" data-id="element-91">
        <h2 className="text-2xl md:text-3xl font-bold text-gold mb-4 font-serif" data-id="element-92">
          🧠 EUREKALABS.STORE™
        </h2>
        <p className="text-cream/90 text-base md:text-lg mb-2 font-medium" data-id="element-93">
          El sistema de intervención clínica N°1 para terapeutas de alimentación
          infantil.
        </p>
        <p className="text-gold/80 italic mb-8 font-serif text-lg" data-id="element-94">
          Porque intervenir con criterio no debería costarte años de prueba y
          error.
        </p>

        <div className="flex flex-col md:flex-row justify-center items-center gap-4 text-cream/70 text-sm mb-8 font-medium bg-black/20 py-3 px-6 rounded-full inline-flex border border-white/10" data-id="element-95">
          <span data-id="element-96">📧 elsoporte.tienda@gmail.com</span>
          <span className="hidden md:inline text-gold" data-id="element-97">•</span>
          <span data-id="element-98">🌐 www.eurekalabs.store</span>
        </div>

        <p className="text-cream/40 text-xs mb-8" data-id="element-99">
          © EurekaLabs.store™ 2026 — Todos los derechos reservados.
        </p>

        <p className="text-lg md:text-xl text-gold font-semibold font-sans leading-relaxed" data-id="element-100">
          "Tus pacientes tienen un sistema nervioso que espera ser entendido. La
          diferencia es si llegás con el criterio para leerlo o a adivinar." 🧠
        </p>
      </div>
    </footer>;
}